import React, { useState } from 'react';

const FAQ = ({ faqData }) => {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <div className="container py-5 w-screen">
      <div className="text-center mb-5">
        <h2 className="fw-bold">FAQs</h2>
        <p className="text-muted">Explore frequently asked questions</p>
      </div>

      <div className="accordion" id="faqAccordion">
        {faqData.map((item, index) => (
          <div className="accordion-item mb-3 border rounded shadow-sm mx-5" key={index}>
            <h2 className="accordion-header">
              <button
                className={`accordion-button ${activeIndex === index ? '' : 'collapsed'} fw-semibold`}
                type="button"
                onClick={() => setActiveIndex(activeIndex === index ? null : index)}
                aria-expanded={activeIndex === index}
              >
                {item.question}
              </button>
            </h2>
            <div
              className={`accordion-collapse collapse ${activeIndex === index ? 'show' : ''}`}
            >
              <div className="accordion-body text-secondary">
                <span
                  dangerouslySetInnerHTML={{ __html: item.answer }}
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FAQ;